import React, { useEffect, useState } from "react";
import { Container, Col, Navbar, Nav } from "react-bootstrap";
import "./header.scss";

function Header() {
  const [fixed, setFixed] = useState(false);
  const [active, setActive] = useState("");
  const [scrollActive, setScrollActive] = useState(0);

  const handleScroll = (e) => {
    let nav = document.getElementById("nav");
    let navHeight;
    if (nav) {
      navHeight = nav.getBoundingClientRect().height;
    } else {
      return;
    }

    setScrollActive(window.pageYOffset);

    if (scrollActive >= 0 && scrollActive <= 594) {
      setActive("");
    }
    if (navHeight < window.pageYOffset) {
      setFixed(true);
    } else {
      setFixed(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  });

  const handleNavigate = (e) => {
    e.preventDefault();
    const id = e.currentTarget.getAttribute("href").slice(1);
    const element = document.getElementById(id);

    if (id) {
      setActive(id);
    }
    const nav = document.getElementById("nav");
    const linkContainer = document.querySelector(".links-container");
    let navHeight = nav.getBoundingClientRect().height;
    let containerHeight = linkContainer.getBoundingClientRect().height;
    const fixedNav = nav.classList.contains("fixed-nav");

    let position = element.offsetTop - navHeight;
    if (!fixedNav) {
      position = position - navHeight - 94;
    }

    if (navHeight > 78) {
      position = position + containerHeight + 104;
    }

    window.scrollTo({
      left: 0,
      top: position,
    });
  };

  return (
    <header id="home" className="header">
      <Navbar
        id="nav"
        fixed="top"
        collapseOnSelect
        expand="lg"
        bg="dark"
        className={!fixed ? "stk-nav" : "stk-nav stk-color"}
        variant="dark"
      >
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto nvbr links-container">
            <Nav.Link
              className={
                active === "home" || (scrollActive >= 0 && scrollActive <= 594)
                  ? "links-container-link active"
                  : "links-container-link"
              }
              onClick={(e) => handleNavigate(e)}
              href="#home"
            >
              home
            </Nav.Link>
            <Nav.Link
              className={
                active === "portfolio" || (scrollActive >= 594 && scrollActive <= 1641)
                  ? "links-container-link active"
                  : "links-container-link"
              }
              onClick={(e) => handleNavigate(e)}
              href="#portfolio"
            >
              Portfolio
            </Nav.Link>
            <Nav.Link
              className={
                active === "about" || (scrollActive >= 1641 && scrollActive <= 2460)
                  ? "links-container-link active"
                  : "links-container-link"
              }
              onClick={(e) => handleNavigate(e)}
              href="#about"
            >
              About
            </Nav.Link>
            <Nav.Link
              className={
                active === "resume" || (scrollActive >= 2460 && scrollActive <= 3800)
                  ? "links-container-link active"
                  : "links-container-link"
              }
              onClick={(e) => handleNavigate(e)}
              href="#resume"
            >
              Resume
            </Nav.Link>
            <Nav.Link
              className={
                active === "contact" || scrollActive >= 3800
                  ? "links-container-link active"
                  : "links-container-link"
              }
              onClick={(e) => handleNavigate(e)}
              href="#contact"
            >
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <Container className="banner-container">
        <Col md={10} className="pt-5 banner">
          <h1 className="banner-hello">
            Hello, I'm
            <span className="banner-hello-name">
              <strong className="d-block">Shmagi Gavashelashvili</strong>
            </span>
          </h1>
          <div className="banner-hello-job">Software Engineer</div>
        </Col>
      </Container>
    </header>
  );
}

export default Header;
